import axios from 'axios'

import { serverURL } from '@monorepo/core/config'

export const apiClient = axios.create({
  baseURL: serverURL + '/api',
  // withCredentials: true,
})
